/**
 * Refresh site
 * */

window.TV2 = window.TV2 || {};

window.TV2.refresh = (refreshInterval) => {
  const interval = (refreshInterval || 600) * 1000;
  let timerId;
  let videoStarted;

  const debounce =
    (fn, delay) =>
    (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      if (!videoStarted) {
        timerId = setTimeout(() => {
          fn(...args);
          timerId = null;
        }, delay);
      }
    };

  const timeout = debounce(() => {
    if (
      typeof window.refreshEnabled === 'undefined' ||
      window.refreshEnabled === null ||
      window.refreshEnabled === true
    ) {
      const comscoreRefreshUrl =
        window.location.search !== '' ? `${window.location.search}&r=refresh` : '?r=refresh';

      // Add parameter to url if it doesn't exists, reload if it does
      if (window.location.search.indexOf('r=refresh') === -1) {
        window.location.search = comscoreRefreshUrl;
      } else {
        window.location.reload();
      }
    }
  }, interval);

  timeout();

  window.addEventListener('video:playbackStarted', () => {
    clearTimeout(timerId);
    videoStarted = true;
  });

  window.addEventListener('scroll', timeout);
  window.addEventListener('keyup', timeout);
};

window.TV2.disableRefresh = (r = true) => {
  window.refreshEnabled = !r;
};
